import React, { Fragment, useState, useEffect } from 'react';
import clsx from 'clsx';

import { SvgIcon } from "@material-ui/core";
import StorefrontIcon from '@material-ui/icons/Storefront';

import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar';
import Container from '@material-ui/core/Container';
import Tooltip from '@material-ui/core/Tooltip';

import ZachHappelDrawerLogo from './ZachHappelDrawerLogo';
import { Zoom } from '@material-ui/core';


import { Link as RouterLink } from 'react-router-dom';
import { Toolbar, AppBar, Typography } from "@material-ui/core";

//import { ReactComponent as HappelSolutionsTransparent}  from '../../../Assets/photos/HappelSolutionsTransparent.svg'
import HappelSolutionsDrawerLogo from './HappelSolutionsDrawerLogo';


import useStyles from './styles'

function ListItemLink(props) {
  const { icon, primary, to, secondary, secondaryStyles } = props;
  
  const renderLink = React.useMemo(
    
    () => React.forwardRef((itemProps, ref) => <RouterLink to={to} ref={ref} {...itemProps} />),
    [to],
  );

 
  if (secondary &&  secondaryStyles) {
    console.log('Secondary: ', secondary);
    console.log('Secondary Styles: ', secondaryStyles);
    //const secondary_sx = secondary.props.children.props.sx;
    //console.log('SX Props: ', secondary_sx);
    return (
      <li>
        <ListItem button component={renderLink}>
          {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
          <ListItemText primary={primary} 
            secondary={
                <Fragment>
                    <Typography style={{...secondaryStyles}}>
                      {secondary}
                    </Typography>
                </Fragment>
            }
         />
        </ListItem>
      </li>
    );
  }
//          { ((icon) && icon === 'contact') ? <ListItemIcon> <PermContactCalendarIcon/> </ListItemIcon> : null }

  else {
    return (
      <li>
      <ListItem button component={renderLink}>
        {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
    )
  }
  
}


//          <ListItemText secondary={secondary} style={secondaryStyles} /**sx={secondary_sx}*/ /> : null }



/**
<ListItem button key={directoryObject.title}>
  <ListItemIcon> <MailIcon /></ListItemIcon>
  <ListItemText primary={directoryObject.title} />
</ListItem>
*/

/**
 * @menuInteractionRecorded = when touch/click registered on menu bar, turns true
 *    Used for closing the tooltip once the menu bar is touched, because it is now clear that the user knows what to do
 * @param {*} param0 
 * @returns 
 */
export default function FixedDrawerMenu( { containerDetailsAndDirectory }) {

    const classes = useStyles();
    const container_title = containerDetailsAndDirectory["title"];
    const container_emoji = containerDetailsAndDirectory["emoji"];
    const full_container_title = container_emoji + " " + container_title;
    //const full_container_title = {happelSolutionsLogo} + " " + container_title;
    
    const logoBurgerDom = document.getElementsByClassName("DrawerLogoTextContainer")[0];
    //const logoBurgerDom = document.getElementById("logoBurgerUndoRotate");
    const [state, setState] = React.useState({ top: false });
    const [parsedDirectory, setParsedDirectory] = React.useState(null)
    const [logoRotated, setLogoRotated] = React.useState(false);
    const [menuOpen, setMenuOpen] = React.useState(false)
    const [logoDomElement, setLogoDomElement] = React.useState(null)
    const [showToolTip, setShowToolTip] = React.useState(false)
    const [menuInteractionRecorded, setMenuInteractionRecorded] = React.useState(false)
    const isMobile = (window.navigator.userAgent).includes('Mobile')



    const toggleDrawer = (anchor, open) => (event) => {

      setMenuInteractionRecorded(true) // Register interaction with menu bar
      
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }

        setMenuOpen(!menuOpen);
        setState({ ...state, [anchor]: open });
    };


    // Remove the current page's directory object from the list containing the directory objects
    const parseDirectoryList = ( directory, currentTitle ) => {
      var parsed_directory = [];
      for ( var i = 0; i <= directory.length - 1; i++ ) {
         if (directory[i].title !== currentTitle)  {
           parsed_directory.push(directory[i])  
      }}
      setParsedDirectory(parsed_directory)
    }

    
    const getLogoDomElement = () => {
      setLogoDomElement(document.getElementsByClassName("DrawerMenuLogo")[0])
    }


    const updateLogoPosition = ( menuOpen ) => {
        if ( menuOpen === true ) {
          if (logoBurgerDom !== null) {
            logoBurgerDom.id = "logoBurgerRotated";
            //alert(logoBurgerDom.id)
          } else {
            logoBurgerDom.id = "logoBurgerUndoRotate"
          }
        }

        if ( menuOpen === false ) {
          if ( logoBurgerDom !== null ) {
            try {
              if (logoBurgerDom.id === "logoBurgerRotated") {
                //alert('Yes')
                logoBurgerDom.id = "logoBurgerUndoRotate";
            
              }
            } catch {
              console.log()
              
            }
          }
        }
      }
      
    const presentToolTip = () => {
     
     /**  setTimeout(()=> {
        localStorage.setItem('toolTipShown', true)
        setShowToolTip(true)
        setTimeout( () => {
          setShowToolTip(false)   
        }, 6000)

      }, 3000)
      */
    }

    useEffect(() => {
     
      if(window.location.pathname !== '/old') {
        if (parsedDirectory === null) parseDirectoryList( containerDetailsAndDirectory["directory"], containerDetailsAndDirectory["title"] )
      }

     // if ( localStorage.getItem('toolTipShown') === null) {
        // show tooltip function
        presentToolTip();
     // }

      updateLogoPosition(menuOpen);


      // if menuOpen == add rotate logo id
      // if menuOpen is false == remove rotate logo id and replace it with something else

      // set classname within svg component .jsx file, getel by class and use [0]
      
    })

    const list = (anchor) => (
        <div
          className={clsx(classes.list, {
            [classes.fullList]: anchor === 'top' || anchor === 'bottom',
          })}
          role="presentation"
          onClick={ () => { if (parsedDirectory !== null) toggleDrawer(anchor, false)}}
          onKeyDown={ () => { if (parsedDirectory !== null) toggleDrawer(anchor, false)}}
        >
          
            {
              (parsedDirectory !== null ? (
                <List style={{paddingTop: '50px', paddingBottom: '0'}}>
                  {parsedDirectory.map((directoryObject, index) => (
                    <>
                    <Divider/>
                      <ListItemLink 
                          to={directoryObject.path}
                          primary={directoryObject.title}
                          icon={directoryObject.icon}
                        />

                        </>
                  ))}

                </List>
              ) : null)
            }
            
         
          
          
        </div>
    );

// /className = { isMain ? classes.main_title : classes.secondary_title }
// {double_space_emoji.replace(/ /g, "\u00a0")}
//  {title}
// Padding of 0px on Toolbar removes that which is already, automatically set with the gutters (? I forget if i implented this or not, still getting chops refined again)
    return (
        
        <div>
        
            {['top'].map((anchor) => (
            
            <React.Fragment key={anchor}>

                <AppBar
                    onClick={toggleDrawer(anchor, !state['top'])}
                    style = {{
                                borderTopLeftRadius: '0.5rem',
                                borderTopRightRadius: '0.5rem',
                                color: 'black',
                                height: '2.9rem',
                                zIndex: '5',
                    }} id={'fixedDrawerMenu'}>

                    <Tooltip id='menuTooltip' 
                      className={classes.NavigationTooltip}
                      styles={{
                        marginTop: '10px',
                
                        //boxShadow: theme.shadows[1],
                        fontSize: '11',
                      }}
                      title={(isMobile) ? "Touch here to open menu" : "Click here to open menu"}
                      placement="bottom-start"
                      TransitionComponent={Zoom}
                      open={showToolTip && !menuInteractionRecorded} 
                      arrow>
                      
                      
                      <Toolbar  style={{ position: 'relative', paddingLeft: '0px', paddingRight:'0px' /**paddingBottom: '1vh',**/}} >

                          <Container id={'fixedDrawerMenu1'} style={{
                            //marginLeft: '-16px',
                            //marginRight: '16px',
                            //marginTop: '1vh',
                            display: 'flex',
                            maxWidth: 'unset',
                            height: '100%',
                            paddingLeft: '0px',
                            paddingRight: '0px',
                            backgroundColor: '#342e2e',
                            color: '#fff',
                            background: "linear-gradient(90deg, rgba(0,0,0,1) 0%, rgba(56,56,70,1) 22%, rgba(87,87,117,1) 41%, rgba(94,94,125,1) 48%, rgba(92,92,125,1) 53%, rgba(67,67,83,1) 71%, rgba(36,36,57,1) 85%, rgba(0,0,0,1) 95%)"

                          }} >
                              
                              <ZachHappelDrawerLogo />
                              
                              <Container class="DrawerLogoTextContainer" className={classes.DrawerLogoTextContainer} 
                              style={{
                                width: '4%',
                                paddingTop: '0.75vh',
                                height: '.3rem',
                                margin: 0,
                                padding: 0,
                                position: "relative",
                                fontFamily: "Open Sans",
                                fontWeight: "700",
                                lineHeight: "82%",
                                transform: "scale(2, 3)",
                                fontSize: "1.25rem", 
                                //backgroundColor:'red',
                              }}> 
                                

                              </Container>
                              
                              <Typography variant="h6" className={classes.TitleText} style={{
                                display: 'flex',
                                fontWeight: 500,
                                fontSize: '1rem',
                                letterSpacing: '2.9px',
                                lineHeight: '2',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                marginBottom: '1vh',
                                marginTop: '4px',
                                flexGrow: '2',
                                justifyContent: 'center',
                                fontFamily: 'AvenirLTStd-Book',
                                userSelect: 'none',
                                //backgroundColor: '#121212',
                                

                              }}>
                                {container_title}
                              </Typography>

                          </Container>    
                        
                      </Toolbar>

                  </Tooltip>

                </AppBar>
            
             
          
                <Drawer 
                    anchor={anchor} 
                    open={state[anchor]} 
                    onClose={toggleDrawer(anchor, false)}
                    style = {{ zIndex: '2', fontSize: '0.8rem'}}
                    >
                    {list(anchor)}
                </Drawer>

            </React.Fragment>
            ))}
        </div>
    )
}

//                       {full_container_title}



//<Container className={classes.HappelSolutionsLogoContainer}>
//                                <ListItemLink primary={'E Commerce'} to={'/ecommerce/'} icon={<InboxIcon/>}/>
//<HappelSolutionsDrawerLogo/>


/**
 * 
 * <Divider />
          
          <List>
            
              <ListItemLink 
                 primary={'E Commerce'}
                 to={'/ecommerce/'} 
                 icon={<StorefrontIcon/>}
                 secondary={'A fully functional e-commerce example'}
                 secondaryStyles={
                   {fontFamily: "AvenirLTStd-Book",
                    color: "blue", 
                    lineHeight: "1.14",
                    fontSize: ".8rem",
                  }}
              />
                
             
             
          </List>
 */

          //                                <a class="DrawerLogoText" href="#"> Zacharie</a>
